import { createAppWrap } from '../../create_app_wrap';
import setupMixin from './mixin';

const view = '[data-view="setup-finish"]';
const init = () => {
    /**

     * Vueオブジェクト
     * @type {Vue|any}
     */
    createAppWrap({
        el: view,
        mixins: [
            setupMixin,
        ],
    });
};

if (document.querySelector(view)) {
    init();
}
